/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BadRequestResponse,
  ConflictResponse,
  EnsureKnowledgeBaseCase200,
  ForbiddenResponse,
  InternalServerErrorResponse,
  NotFoundResponse,
  UnauthorizedResponse
} from '.././model'
import { customInstance } from '../../custom-instance';


// eslint-disable-next-line
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;


/**
 * @summary Ensure knowledge base case
 */
export const ensureKnowledgeBaseCase = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EnsureKnowledgeBaseCase200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/knowledge/ensure-case`, method: 'get', signal
    },
      options);
    }
  

export const getEnsureKnowledgeBaseCaseQueryKey = (organizationId: string,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/knowledge/ensure-case`] as const;
    }

    
export const getEnsureKnowledgeBaseCaseQueryOptions = <TData = Awaited<ReturnType<typeof ensureKnowledgeBaseCase>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ensureKnowledgeBaseCase>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEnsureKnowledgeBaseCaseQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ensureKnowledgeBaseCase>>> = ({ signal }) => ensureKnowledgeBaseCase(organizationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ensureKnowledgeBaseCase>>, TError, TData> & { queryKey: QueryKey }
}

export type EnsureKnowledgeBaseCaseQueryResult = NonNullable<Awaited<ReturnType<typeof ensureKnowledgeBaseCase>>>
export type EnsureKnowledgeBaseCaseQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

/**
 * @summary Ensure knowledge base case
 */
export const useEnsureKnowledgeBaseCase = <TData = Awaited<ReturnType<typeof ensureKnowledgeBaseCase>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ensureKnowledgeBaseCase>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getEnsureKnowledgeBaseCaseQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

